import {
  CartCountStatusTypes,
  CartCountStatusActionTypes
} from './cartCountStatusTypes';
import { QuoteCountStatusRequest } from '@/main/models/request/quoteRequest';
import { CartResponseCount } from '@/main/models/response';

export function getCartCountStatus(
  request: QuoteCountStatusRequest
): CartCountStatusActionTypes {
  return {
    type: CartCountStatusTypes.GET_CART_COUNT_STATUS,
    payload: {
      request: request
    }
  };
}

export function saveCartCountStatus(
  data: CartResponseCount[] | null,
  isError: boolean,
  errorMessages: string[] | null
): CartCountStatusActionTypes {
  return {
    type: CartCountStatusTypes.SAVE_CART_COUNT_STATUS,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerCartCountStatus(): CartCountStatusActionTypes {
  return {
    type: CartCountStatusTypes.RESET_REDUCER_CART_COUNT_STATUS
  };
}